/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-nested-ternary */
import { Col, Row } from 'antd';
import _ from 'lodash';
import { QuestionComponentProps } from '../../type';
import { HeaderCommon, QuestionNumber, QuestionText } from '../RenderCommon';

const Unscramble = ({ questionIndex, questionData, isCombineChild }: QuestionComponentProps) => {
  // const optionType = questionData.optionType.toUpperCase();
  const splitCharacter = questionData.settings.arrangementType === 'word' ? '' : questionData.settings.arrangementType === 'sentence' ? ' ' : '|';
  const shuffedArr = Array.isArray(questionData.answers) ? _.shuffle(questionData.answers ?? '') : _.shuffle((questionData.answers ?? '').split(splitCharacter));

  const renderAnswers = () => {
    if (splitCharacter === '') {
      return (
        <Row gutter={24} align='middle'>
          <Col>
            <div style={{ display: 'flex', justifyContent: 'center' }}>{questionData.imageUrl ? <img src={questionData.imageUrl} style={{ maxHeight: 100, maxWidth: 400 }} /> : null}</div>
          </Col>
          <Col>
            <div style={{ marginBottom: 5 }}>
              <QuestionNumber isCombineChild={isCombineChild} questionIndex={questionIndex} />
              {shuffedArr.join('   ')}
            </div>
            <div style={{ borderBottom: '1px dotted black', height: 20 }} />
          </Col>
        </Row>
      );
    }
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'center' }}>{questionData.imageUrl ? <img src={questionData.imageUrl} style={{ maxHeight: 200 }} /> : null}</div>
        <div style={{ marginBottom: 5 }}>
          <QuestionNumber isCombineChild={isCombineChild} questionIndex={questionIndex} />
          {shuffedArr.join(' / ')}
        </div>
        <div style={{ borderBottom: '1px dotted black', height: 20 }} />
      </>
    );
  };
  return (
    <div style={{ marginLeft: isCombineChild ? 5 : 0 }}>
      <HeaderCommon key={`unscramble-${questionData.id}`} questionIndex={questionIndex} questionData={questionData} isCombineChild={isCombineChild} />
      <QuestionText key={questionIndex} questionText={questionData.questionText} />
      {renderAnswers()}
    </div>
  );
};

export default Unscramble;
